import React from 'react';
import { Quote } from 'lucide-react';

const TestimonialCard = ({ testimonial, primaryColor = '#7C3AED', accentColor = null }) => {
  return (
    <div
      className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow"
      style={{
        border: '1px solid #E5E7EB',
        borderLeft: accentColor ? `3px solid ${accentColor}` : '1px solid #E5E7EB',
      }}
    >
      <div className="mb-4">
        <Quote className="w-8 h-8 opacity-40" style={{ color: primaryColor }} />
      </div>

      <p className="text-gray-700 italic mb-4 leading-relaxed">
        "{testimonial.testimonial}"
      </p>

      <div className="border-t border-gray-100 pt-4">
        <p className="font-semibold text-gray-900 mb-1">
          — {testimonial.clientName}
        </p>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          {testimonial.location && <span>{testimonial.location}</span>}
          {testimonial.location && testimonial.date && <span>·</span>}
          {testimonial.date && <span>{testimonial.date}</span>}
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
